import { render, staticRenderFns } from "./complainApplication.vue?vue&type=template&id=7bc52da2&scoped=true"
import script from "./complainApplication.vue?vue&type=script&lang=js"
export * from "./complainApplication.vue?vue&type=script&lang=js"
import style0 from "./complainApplication.vue?vue&type=style&index=0&id=7bc52da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc52da2",
  null
  
)

export default component.exports